var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',{attrs:{"value":_vm.selectedCohorts,"options":_vm.cohortList,"multiple":true,"label":"name"},on:{"select":_vm.addCohort,"remove":_vm.removeCohort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }